import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const RfqBanner = () => (
  <section data-testid="rfq-banner" className="bg-[#0B1329]">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 md:py-20">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-400">
              Request for Quotation
            </p>
            <h2 className="mt-3 text-2xl sm:text-3xl font-bold tracking-tight text-white">
              Have a drawing or manufacturing requirement?
            </h2>
            <p className="mt-3 text-base text-slate-300 leading-relaxed">
              Send us your drawing or technical specification and contact our team for a quotation.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="rfq-banner-button"
            className="inline-flex shrink-0 items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-semibold px-7 py-3.5 rounded-sm transition-colors duration-150"
          >
            Request a Quote <ArrowRight size={16} />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default RfqBanner;
